import React from "react";
import {Button} from "../Inputs/";

interface ResultsPagerProps {
    currentPage?: number;
    disabled?: boolean;
    handleFirstClick: () => void;
    handlePreviousClick: () => void;
    handleNextClick: () => void;
    handleLastClick: () => void;
    isSecondaryPager?: boolean;
    recordsPerPage?: number;
    totalRecords?: number;
}

export const ResultsPager: React.FC<ResultsPagerProps> = ({
    currentPage,
    disabled,
    handleFirstClick,
    handlePreviousClick,
    handleNextClick,
    handleLastClick,
    isSecondaryPager,
    recordsPerPage,
    totalRecords,
}) => {
    const hideSecondaryPager = isSecondaryPager && totalRecords! < recordsPerPage!;
    if (!totalRecords || hideSecondaryPager) return null;

    let activePage = currentPage!;
    if( totalRecords <= recordsPerPage!) {
        activePage = 1;
    }

    let firstVisibleRecord = (activePage - 1) * recordsPerPage! + 1;

    let recordsOnCurrentPage = activePage * recordsPerPage!;
    let lastVisibleRecord =
        totalRecords > recordsOnCurrentPage ? (activePage - 1) * recordsPerPage! + recordsPerPage! : totalRecords;

    let cantNavigateBackward = activePage === 1;
    let cantNavigateForward = lastVisibleRecord >= totalRecords;

    return (
        <>
            {
                cantNavigateBackward && cantNavigateForward &&
                <div>
                    <div className={`pager__text`}>
                        {`Displaying ${totalRecords} Records`}
                    </div>
                </div>
            }
            {
                (!cantNavigateBackward || !cantNavigateForward) &&
                <nav aria-label="Search Results">
                    <div className="pager">
                        <div className="pager__nav-group">
                            <Button
                                onClick={handleFirstClick}
                                name="btnFirstPage"
                                label="First"
                                disabled={disabled || cantNavigateBackward}
                            />
                            <Button
                                onClick={handlePreviousClick}
                                name="btnPreviousPage"
                                label="Previous"
                                disabled={disabled || cantNavigateBackward}
                            />
                        </div>
                        <div className="pager__text">
                            <span className="show-for-sr"> Displaying Records </span>
                            <span>{`${firstVisibleRecord} – ${lastVisibleRecord} of ${totalRecords}`}</span>
                            <span className="show-for-sr"> Total Records </span>
                        </div>
                        <div className="pager__nav-group">
                            <Button
                                onClick={handleNextClick}
                                name="btnNextPage"
                                label="Next"
                                isPrimary
                                disabled={disabled || cantNavigateForward}
                            />
                            <Button
                                onClick={handleLastClick}
                                name="btnLastPage"
                                label="Last"
                                isPrimary
                                disabled={disabled || cantNavigateForward}
                            />
                        </div>
                    </div>
                </nav>
            }
        </>
    );
};
